import { useLLMOutput } from "../../../lib/llm-ui";
import { collapseBlock, markdownBlock, textUpdateBlock } from "../Blocks";
import type { AIHistoryMessage } from "../../types/HistoryMessage";

interface AssistantMessageProps {
  message: AIHistoryMessage;
  index: number;
}

export function AssistantMessage({ message, index }: AssistantMessageProps) {
  const { blockMatches } = useLLMOutput({
    llmOutput: message.content,
    blocks: [textUpdateBlock, collapseBlock],
    fallbackComponent: markdownBlock,
  });

  return (
    <div key={`assistant-${index}`} className="w-full">
      {blockMatches.length > 0 ? (
        <div className="space-y-4">
          {blockMatches.map((blockMatch, blockIndex) => {
            const Component = blockMatch.block.component;
            return (
              <Component
                key={`block-${blockIndex}-${blockMatch.startIndex}`}
                blockMatch={blockMatch}
              />
            );
          })}
        </div>
      ) : null}
    </div>
  );
}
